module.exports = __webpack_public_path__ + "media/images/emblems/Gruesch_wappen-8e0997aef0284459bf4be9c30f32f0e2.svg";